export const COMMON_CARTRIDGE_SPEC = 'Common Cartridge'
export const COMMON_CARTRIDGE_SPEC_V1P2 = '1p2'
export const COMMON_CARTRIDGE_SPEC_V1P3 = '1p3'
